import { createAction } from '@reduxjs/toolkit';
import { RESET_PAYMENT_ERRORS, SET_IS_PAYMENT_NOT_ALLOWED, SET_IS_WENT_WRONG, SET_PAYMENT_ERROR_CONDITION, SET_SHOULD_RETRY, SET_TERMINAL_PAYMENT_RESULT, TERMINAL_PAYMENT_IS_PROCESSING, } from './actionTypes';
export const setIsTerminalPaymentIsProcessing = createAction(TERMINAL_PAYMENT_IS_PROCESSING);
export const setIsPaymentNotAllowed = createAction(SET_IS_PAYMENT_NOT_ALLOWED);
export const setTerminalResult = createAction(SET_TERMINAL_PAYMENT_RESULT);
export const setPaymentErrorCondition = createAction(SET_PAYMENT_ERROR_CONDITION);
export const setShouldRetry = createAction(SET_SHOULD_RETRY);
export const setIsWentWrong = createAction(SET_IS_WENT_WRONG);
export const resetPaymentErrors = createAction(RESET_PAYMENT_ERRORS);
